module.exports = __webpack_public_path__ + "bin/img/favicon_big.57ee278.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/favicon_big.png
// module id = A8bz
// module chunks = 1